/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { getAddOns, getAddOnsCode } from 'state/actions/ratingsState/addOnsStatus';
// material
import RatingsCounterSection from 'pages/dashboard/ratings/ratingsmanager/addons/ratingscountersection/ratingscountersection';
// utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/ratings/ratingsmanager/addons/addons_styles';


/* ========== ~~~~~~~~~~ RATINGS ADDONS PAGE ~~~~~~~~~~ ========== */
const AddOns = (props) => {
  const dispatch = useDispatch();
  const siteUUID = useSelector(state => state.ratingsState.configStatus.siteUUID);
  const configurations = useSelector(state => state.ratingsState.configStatus.configuration);
  const previousSelectedSiteUUID = useSelector(state => state.ratingsState.addOnsStatus.previousSelectedSiteUUID);

  useEffect(()=>{
    if((siteUUID) && (siteUUID != previousSelectedSiteUUID)) {
      dispatch(getAddOns({data: configurations, siteUUID}));
      dispatch(getAddOnsCode({siteUUID, productType: 'RATING_COUNTER'}));
    }
  },[siteUUID]);

  return(
    <div className={`addons ${props.classes.addons}`}>
      <RatingsCounterSection />
    </div>
  );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AddOns);
